/**
 * Page Rendez-vous (Amelia) : une seule page/shortcode sert les 3 tunnels
 * (flash, "Rendez-vous projet", "Création personnalisée"), chacun étant pré-sélectionné
 * via le paramètre d'URL "ameliaServiceId" (voir helpers/pages.php ->
 * theme_get_rendezvous_url() et le lien construit sur chaque bouton/carte).
 *
 * Ici, on gère juste le cas particulier du tunnel "Création personnalisée" :
 * ce service n'a pas de prix total (tatouage sur-mesure, prix inconnu à
 * l'avance), seulement un acompte fixe payé à 100% — on relabellise donc le
 * "Prix" affiché par le widget Amelia en "Acompte" pour ce service précis,
 * pour ne pas laisser croire que c'est le prix total du tatouage.
 */
export function render ({ wp }) {

  const params    = new URLSearchParams(window.location.search)
  const serviceId = params.get('ameliaServiceId')

  if (!serviceId || Number(serviceId) !== Number(wp.amelia_service_id_rdv)) return

  const container = document.querySelector('.c-page-rendezvous__booking')
  if (!container) return

  const relabel = () => {
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT)
    let node
    while ((node = walker.nextNode())) {
      if (/\bPrix\b/.test(node.nodeValue)) {
        node.nodeValue = node.nodeValue.replace(/\bPrix\b/g, 'Acompte')
      }
    }
  }

  // Amelia injecte son interface de façon asynchrone après le chargement du
  // shortcode (React monté côté client) : on observe le conteneur plutôt
  // que de dépendre d'un timing précis, et on relabellise à chaque étape.
  relabel()
  new MutationObserver(relabel).observe(container, {
    childList: true,
    subtree: true,
    characterData: true
  })

}
